







import Vue from 'vue'
import style from './style.module.scss'

export default Vue.extend({
name: 'info-block-row',
  components: {

  },
  props: {
    title: String
  },
  data() {
    return {
    style: style
    }
  },
})
